import React, { useState, useEffect, useRef } from "react";
import { Input } from "@/components/ui/input";
import { Loader, X } from "lucide-react";

// ─── Autocomplete genérico ────────────────────────────────────
// Extraído de ProspectPage.jsx pra ser reaproveitado também pela página
// pública "Comprar Leads" (ComprarLeadsPage.jsx).
export function AutocompleteInput({ value, onChange, onSelect, suggestions, loading, placeholder, icon: Icon, onClear }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  useEffect(() => { setOpen(suggestions.length > 0 && value.length >= 2); }, [suggestions, value]);

  return (
    <div className="relative" ref={ref}>
      {Icon && <Icon className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-500 z-10" />}
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={() => suggestions.length > 0 && value.length >= 2 && setOpen(true)}
        className={`${Icon ? "pl-9" : "pl-3"} ${onClear && value ? "pr-8" : ""} bg-zinc-800 border-zinc-700 text-zinc-100`}
      />
      {onClear && value && (
        <button onClick={onClear} className="absolute right-2 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-zinc-300">
          <X className="h-3.5 w-3.5" />
        </button>
      )}
      {loading && <Loader className="absolute right-3 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-zinc-500 animate-spin" />}
      {open && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-zinc-800 border border-zinc-700 rounded-lg shadow-xl z-50 max-h-52 overflow-y-auto">
          {suggestions.map((s, i) => (
            <button key={i} onMouseDown={(e) => { e.preventDefault(); onSelect(s); setOpen(false); }}
              className="w-full text-left px-3 py-2 text-sm text-zinc-200 hover:bg-zinc-700 transition-colors first:rounded-t-lg last:rounded-b-lg">
              {s}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default AutocompleteInput;
